export default __webpack_public_path__ + "8cdab403d6f38713eb809db4702c9864.glb";